<div class="body">
  <mat-toolbar class="toolbar">
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title dashboard-toolbar-title">Shielding Control Forms</span>
        </div>
        <div class="col-sm-12 col-md-3 d-flex align-items-start flex-column justify-content-center">
          <h1 class="blue" id="serialNumber" matTooltip="Open SCFs with active hold points">
            SCF Hold Points
          </h1>
          <span class="status blue">Live Status</span>
        </div>
        <div class="col-12 col-md-4 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" class="no-subscript filter-field">
            <mat-label>Filter SCFs</mat-label>
            <input
              matInput
              type="text"
              [formControl]="filterControl"
              placeholder="Requester, location, serial number, or description"
            />
            <button
              *ngIf="filterControl.value"
              mat-icon-button
              matSuffix
              aria-label="Clear filter"
              (click)="filterControl.setValue('')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end">
          <div class="d-flex small d-print-none">
            {{ filteredRows.length }} open SCF{{ filteredRows.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <div class="sidenav-content">
        <div class="dashboard-main">
      <div *ngIf="error" class="dashboard-message error-message">
            Hold-point status could not be loaded. Refresh the page and try again.
          </div>

          <div *ngIf="!loading && !error && !filteredRows.length" class="dashboard-message">
            No open SCFs match the current filter.
          </div>

          <div *ngIf="!loading && !error && filteredRows.length" class="matrix-wrapper">
            <table class="status-matrix">
              <thead>
                <tr>
                  <th class="scf-column">SCF</th>
                  <th class="hold-points-column" matTooltip="Each circle represents a signature slot; checked circles are signed">
                    <div class="hold-points-header">
                      <span>Hold Points</span>
                      <div class="legend">
                        <span><i class="legend-box complete"></i>Fully signed</span>
                        <span><i class="legend-box partial"></i>Partially signed</span>
                        <span><i class="legend-box unsigned"></i>Not signed</span>
                        <span><i class="legend-box blocked"></i>Waiting for prior hold point</span>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of filteredRows; trackBy: trackByRow">
                <tr
                  #scfRow
                  [attr.data-scf-serial]="row.serialNo"
                  [class.selected-scf-row]="row.serialNo === selectedSerialNo"
                >
                  <th class="scf-column row-heading">
                    <button
                      type="button"
                      class="serial-link"
                      [ngClass]="row.statusColor"
                      [matTooltip]="stripHtml(row.description)"
                      [matTooltipDisabled]="!stripHtml(row.description)"
                      matTooltipClass="tooltip-white tooltip-wide"
                      matTooltipPosition="right"
                      (click)="openScf(row)"
                    >{{ row.serialNo }}</button>
                    <span class="scf-meta">{{ row.requesterName || 'Requester unavailable' }}</span>
                    <span class="scf-meta">{{ formatLocationNames(row.locationNames) || 'Location unavailable' }}</span>
                    <div *ngIf="row.amendmentHoldPoints?.length" class="amendment-toggle-section">
                      <mat-slide-toggle
                        color="accent"
                        [checked]="isAmendmentHoldPointsVisible(row)"
                        (change)="toggleAmendmentHoldPoints(row, $event.checked)"
                      >Show pending amendment hold points</mat-slide-toggle>
                    </div>
                  </th>
                  <td class="hold-points-column">
                    <div class="hold-point-list">
                      <div *ngFor="let cell of row.holdPoints" class="hold-point-item">
                        <div
                          class="hold-point-label"
                          [matTooltip]="stripHtml(cell.description || cell.name)"
                          matTooltipClass="tooltip-white tooltip-wide"
                          matTooltipPosition="above"
                        >Hold Point {{ cell.number }}</div>
                        <div class="status-box" [ngClass]="cell.state">
                          <div class="signature-list" *ngIf="getRequiredSignatures(cell).length">
                            <span
                              *ngFor="let signature of getRequiredSignatures(cell); trackBy: trackBySignature"
                              [matTooltip]="signatureTooltip(signature)"
                              matTooltipClass="tooltip-white tooltip-wide"
                              matTooltipPosition="below"
                            >
                              <mat-icon [class.signed-icon]="signature.signed">{{ signature.signed ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="row.amendmentHoldPoints?.length && isAmendmentHoldPointsVisible(row)"
                      class="amendment-hold-point-section"
                    >
                      <div class="hold-point-list amendment-hold-point-list">
                        <div *ngFor="let cell of row.amendmentHoldPoints" class="hold-point-item">
                          <div
                            class="hold-point-label"
                            [matTooltip]="stripHtml(cell.description || cell.name)"
                            matTooltipClass="tooltip-white tooltip-wide"
                            matTooltipPosition="above"
                          >Hold Point {{ cell.number }}</div>
                          <div class="status-box" [ngClass]="cell.state">
                            <div class="signature-list" *ngIf="getRequiredSignatures(cell).length">
                              <span
                                *ngFor="let signature of getRequiredSignatures(cell); trackBy: trackBySignature"
                                [matTooltip]="signatureTooltip(signature)"
                                matTooltipClass="tooltip-white tooltip-wide"
                                matTooltipPosition="below"
                              >
                                <mat-icon [class.signed-icon]="signature.signed">{{ signature.signed ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
  </div>
</div>
